module.exports = __webpack_public_path__ + "static/media/Icon-awesome-paper-plane-red.596075d1.svg";